<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
    <p>{{ data.content }}</p>
</div>
<div mat-dialog-actions>
    <button
            *ngIf="data.negativeButtonText"
            [mat-dialog-close]="false"
            mat-button>
        {{ data.negativeButtonText }}
    </button>
    <button
            *ngIf="data.positiveButtonText"
            [mat-dialog-close]="true"
            mat-button>
        {{ data.positiveButtonText || 'OK' }}
    </button>
</div>
